// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `terms and conditions`
};

const de_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `Allgemeinen Geschäftsbedingungen gelesen`
};

const es_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `términos y condiciones`
};

const fr_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `conditions générales`
};

const fi_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `käyttöehdot`
};

const hi_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `नियम एवं शर्तें`
};

const ja_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `利用規約を読みました`
};

const nl_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `algemene voorwaarden gelezen`
};

const pt_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `termos e condições`
};

const ro_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `termenii și condițiile`
};

const th_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `ข้อกำหนดและเงื่อนไข`
};

const ur_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `شرائط و ضوابط`
};

const zh_hant1_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `條款與條件`
};

const da_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `vilkårene og betingelserne`
};

const it_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `termini e condizioni`
};

const vn_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `điều khoản và điều kiện`
};

const ko_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `이용약관을 읽었습니다`
};

const tr_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `şartlar ve koşullar`
};

const lv_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `noteikumus un nosacījumus`
};

const ar_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `الشروط والأحكام`
};

const bs_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `uslove i odredbe`
};

const sl_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `pogoje uporabe`
};

const id_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `syarat dan ketentuan`
};

const sv_widget_login_terms_link = /** @type {(inputs: {}) => string} */ () => {
	return `villkoren och bestämmelserna`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_terms_link = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_terms_link(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_terms_link", locale)
	if (locale === "en") return en_widget_login_terms_link(inputs)
	if (locale === "de") return de_widget_login_terms_link(inputs)
	if (locale === "es") return es_widget_login_terms_link(inputs)
	if (locale === "fr") return fr_widget_login_terms_link(inputs)
	if (locale === "fi") return fi_widget_login_terms_link(inputs)
	if (locale === "hi") return hi_widget_login_terms_link(inputs)
	if (locale === "ja") return ja_widget_login_terms_link(inputs)
	if (locale === "nl") return nl_widget_login_terms_link(inputs)
	if (locale === "pt") return pt_widget_login_terms_link(inputs)
	if (locale === "ro") return ro_widget_login_terms_link(inputs)
	if (locale === "th") return th_widget_login_terms_link(inputs)
	if (locale === "ur") return ur_widget_login_terms_link(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_terms_link(inputs)
	if (locale === "da") return da_widget_login_terms_link(inputs)
	if (locale === "it") return it_widget_login_terms_link(inputs)
	if (locale === "vn") return vn_widget_login_terms_link(inputs)
	if (locale === "ko") return ko_widget_login_terms_link(inputs)
	if (locale === "tr") return tr_widget_login_terms_link(inputs)
	if (locale === "lv") return lv_widget_login_terms_link(inputs)
	if (locale === "ar") return ar_widget_login_terms_link(inputs)
	if (locale === "bs") return bs_widget_login_terms_link(inputs)
	if (locale === "sl") return sl_widget_login_terms_link(inputs)
	if (locale === "id") return id_widget_login_terms_link(inputs)
	if (locale === "sv") return sv_widget_login_terms_link(inputs)
	return "widget_login_terms_link"
};